/* Scentlegacy on Shopify · scroll film, page motion, finder and the bag. Plain JS, no build step. */
(() => {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
  const smooth = (p, e0, e1) => { const t = clamp((p - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); };
  const RM = matchMedia('(prefers-reduced-motion: reduce)');
  const rng = seed => { let s = seed >>> 0; return () => (s = (s * 1664525 + 1013904223) >>> 0) / 4294967296; };
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  let DATA = { products: [], cart: null };
  try { DATA = JSON.parse($('#sl-data').textContent); } catch (_) {}
  const PRODUCTS = DATA.products || [];
  const byId = Object.fromEntries(PRODUCTS.map(p => [p.id, p]));
  const ROOT = (DATA.root || '/').replace(/\/?$/, '/');

  /* money in the store's own format, without trailing .00 (same as the Liquid side) */
  const money = c => {
    const fmt = DATA.moneyFormat || '${{amount}}';
    const n = c / 100;
    const two = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const none = Math.round(n).toLocaleString('en-US');
    const out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return none;
      if (k === 'amount_with_comma_separator') return two.replace(/,/g, '.').replace(/\.(\d\d)$/, ',$1');
      if (k === 'amount_no_decimals_with_comma_separator') return none.replace(/,/g, '.');
      return two;
    });
    return c % 100 === 0 ? out.replace(/([.,])00(?!\d)/, '') : out;
  };
  /* product names in one style, same rule as snippets/sl-title.liquid */
  const tidy = t => String(t || '').replace(/_/g, ' ').split(' ').map(w => (w.length > 1 && w === w.toUpperCase() && w !== w.toLowerCase()) ? w[0] + w.slice(1).toLowerCase() : w).join(' ');

  /* ============================================================
     1. Split hero headlines into words and characters (once)
     ============================================================ */
  $$('[data-split]').forEach((el, idx) => {
    const mode = el.dataset.split;
    const em = el.dataset.em;
    const text = el.textContent.trim();
    const r = rng(1000 + idx * 97);
    el.textContent = '';
    const sr = document.createElement('span');
    sr.className = 'sr-only';
    sr.textContent = text;
    const vis = document.createElement('span');
    vis.setAttribute('aria-hidden', 'true');
    el.append(sr, vis);
    const words = text.split(' ');
    const total = text.replace(/ /g, '').length;
    const mid = (total - 1) / 2;
    let ci = 0;
    words.forEach((w, wi) => {
      const ws = document.createElement('span');
      ws.className = 'w';
      if (em && w.replace(/[^A-Za-z']/g, '').toLowerCase() === em) ws.classList.add('em');
      if (mode === 'drift') ws.style.setProperty('--th', (wi / words.length * 0.5).toFixed(3));
      if (mode === 'punch') ws.style.setProperty('--th', (wi / words.length * 0.55).toFixed(3));
      if (mode === 'ripple') {
        [...w].forEach(ch => {
          const c = document.createElement('span');
          c.className = 'c';
          c.textContent = ch;
          const d = Math.abs(ci - mid) / (mid || 1);
          c.style.setProperty('--th', (d * 0.32 + r() * 0.04).toFixed(3));
          c.style.setProperty('--jx', ((mid - ci) * 7).toFixed(1) + 'px');
          ws.appendChild(c);
          ci++;
        });
      } else {
        ws.textContent = w;
      }
      vis.appendChild(ws);
      if (wi < words.length - 1) vis.appendChild(document.createTextNode(' '));
    });
  });

  /* ============================================================
     2. The scroll film (home page only)
     ============================================================ */
  const hero = $('.hero');
  let applyHeroMode = () => {};
  let unpinHero = () => {};
  if (hero) {
    const stage = $('.stage');
    const video = $('#hero');
    const poster = $('.poster');
    const ring = $('.ring');
    const VIDEO_URL = hero.dataset.video || '';
    const POSTER_URL = hero.dataset.poster || '';
    const VIDEO_BYTES = +hero.dataset.bytes || 5543306;

    const bands = $$('.band').map(el => ({
      el, a: +el.dataset.a, b: +el.dataset.b,
      ramp: el.dataset.ramp ? +el.dataset.ramp : null,
      op: -1, k: -1, live: null
    }));

    let target = 0, shown = 0, rafId = null, lastTick = 0;
    let heroOnScreen = true, scrubOn = false, heroInited = false;
    let loadK = 0, loadRaf = null;
    let lastScrolled = null;

    const heroProgress = () => {
      const range = hero.offsetHeight - innerHeight;
      if (range <= 0) return 0;
      return clamp(-hero.getBoundingClientRect().top / range, 0, 1);
    };

    const updateCaptions = p => {
      const n = bands.length;
      bands.forEach((B, i) => {
        const { a, b } = B;
        const f = Math.min(0.02, (b - a) / 3);
        const first = i === 0, last = i === n - 1;
        let op;
        if (p < a) op = first ? 1 : 0;
        else if (p > b) op = last ? 1 : 0;
        else op = (first ? 1 : smooth(p, a, a + f)) * (last ? 1 : 1 - smooth(p, b - f, b));
        const ramp = B.ramp || Math.min(0.025, (b - a) * 0.35);
        let k = clamp((p - a) / ramp, 0, 1);
        if (first) k = Math.max(k, loadK);
        if (Math.abs(op - B.op) > 0.004 || ((op === 0 || op === 1) && op !== B.op)) {
          B.el.style.opacity = op.toFixed(3);
          B.op = op;
        }
        if (Math.abs(k - B.k) > 0.008 || ((k === 0 || k === 1) && k !== B.k)) {
          B.el.style.setProperty('--k', k.toFixed(3));
          B.k = k;
        }
        const live = op > 0.5;
        if (live !== B.live) {
          B.el.classList.toggle('live', live);
          B.el.inert = !live;
          B.live = live;
        }
      });
      const scrolled = p > 0.015;
      if (scrolled !== lastScrolled) { stage.classList.toggle('scrolled', scrolled); lastScrolled = scrolled; }
    };

    /* gated, deadlock-safe seeks */
    let seekBusy = false, pendingTime = null;
    const requestSeek = t => {
      if (!video.duration) return;
      t = clamp(t, 0, video.duration - 0.04);
      if (seekBusy) { pendingTime = t; return; }
      if (Math.abs(video.currentTime - t) < 0.001) return;
      seekBusy = true;
      video.currentTime = t;
    };
    video.addEventListener('seeked', () => {
      seekBusy = false;
      if (pendingTime !== null) { const t = pendingTime; pendingTime = null; requestSeek(t); }
    });
    video.addEventListener('error', () => { seekBusy = false; pendingTime = null; failVideo(); });

    /* lerp loop that rests when converged */
    const tick = now => {
      const dt = Math.min(100, now - (lastTick || now));
      lastTick = now;
      shown += (target - shown) * (1 - Math.pow(1 - 0.16, dt / 16.667));
      if (Math.abs(target - shown) < 0.0005) { shown = target; rafId = null; lastTick = 0; }
      else rafId = requestAnimationFrame(tick);
      requestSeek(shown * (video.duration || 0));
      updateCaptions(shown);
    };
    const onScroll = () => {
      if (!scrubOn) return;
      target = heroProgress();
      if (rafId === null && heroOnScreen) rafId = requestAnimationFrame(tick);
    };

    /* band one opens assembled: a one-time load ramp that hands over to scroll */
    const runLoadRamp = () => {
      if (loadK >= 1) return;
      const start = performance.now();
      const step = now => {
        const t = clamp((now - start - 250) / 1500, 0, 1);
        loadK = 1 - Math.pow(1 - t, 3);
        updateCaptions(shown);
        loadRaf = t < 1 ? requestAnimationFrame(step) : null;
      };
      loadRaf = requestAnimationFrame(step);
    };

    /* poster first, then the streamed Blob with an honest ring */
    const initHeroOnce = () => {
      if (heroInited) return;
      heroInited = true;
      poster.style.backgroundImage = `url('${POSTER_URL}')`;
      let started = false;
      const startBlobFetch = () => { if (started) return; started = true; if (!VIDEO_URL) { failVideo(); return; } loadHeroBlob().catch(failVideo); };
      const img = new Image();
      img.onload = startBlobFetch;
      img.onerror = startBlobFetch;
      img.src = POSTER_URL;
      setTimeout(startBlobFetch, 4000);
    };
    const loadHeroBlob = async () => {
      const ctrl = new AbortController();
      let watchdog = setTimeout(() => ctrl.abort(), 20000);
      const res = await fetch(VIDEO_URL, { priority: 'low', signal: ctrl.signal });
      if (!res.ok || !res.body) throw new Error('video ' + res.status);
      const total = Number(res.headers.get('Content-Length')) || VIDEO_BYTES;
      const reader = res.body.getReader();
      const chunks = [];
      let got = 0, lastRing = 0;
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        clearTimeout(watchdog);
        watchdog = setTimeout(() => ctrl.abort(), 20000);
        chunks.push(value);
        got += value.length;
        const frac = Math.min(1, got / total);
        const now = performance.now();
        if (now - lastRing > 100 || frac === 1) { lastRing = now; ring.style.setProperty('--ld', Math.round(126 * (1 - frac))); }
      }
      clearTimeout(watchdog);
      ring.style.setProperty('--ld', 0);
      video.src = URL.createObjectURL(new Blob(chunks, { type: 'video/mp4' }));
      video.load();
      video.addEventListener('canplay', () => {
        requestSeek(heroProgress() * video.duration);
        stage.classList.add('video-ready');
      }, { once: true });
    };
    function failVideo() {
      if (stage.classList.contains('video-failed')) return;
      stage.classList.add('video-failed');
      ring.style.display = 'none';
    }

    /* the five static-hero gates, identical to the CSS, decided live */
    const GATES = [
      '(max-width: 720px)',
      '(orientation: portrait) and (max-width: 1024px)',
      '(orientation: portrait) and (pointer: coarse)',
      '(orientation: landscape) and (pointer: coarse) and (max-height: 560px)',
      '(prefers-reduced-motion: reduce)'
    ];
    const MQLS = GATES.map(q => matchMedia(q));
    const enableScrub = () => {
      if (scrubOn) return;
      scrubOn = true;
      initHeroOnce();
      addEventListener('scroll', onScroll, { passive: true });
      bands.forEach(b => { b.op = -1; b.k = -1; b.live = null; });
      unpinFinalStates();
      target = shown = heroProgress();
      updateCaptions(shown);
      runLoadRamp();
      onScroll();
    };
    const disableScrub = () => {
      if (!scrubOn) return;
      scrubOn = false;
      removeEventListener('scroll', onScroll);
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
      if (loadRaf !== null) { cancelAnimationFrame(loadRaf); loadRaf = null; }
    };
    applyHeroMode = () => { if (MQLS.some(m => m.matches)) disableScrub(); else enableScrub(); };
    MQLS.forEach(m => m.addEventListener('change', applyHeroMode));
    addEventListener('resize', onScroll, { passive: true });
    new IntersectionObserver(es => { heroOnScreen = es[0].isIntersecting; if (heroOnScreen) onScroll(); }).observe(hero);
  }

  /* ============================================================
     3. Page motion: reveals, self-drawing orbits, ticker, motes
     ============================================================ */
  const reveals = $$('.reveal');
  const revealIO = new IntersectionObserver(es => {
    es.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target;
      const parts = $$('.part, .card', el);
      parts.forEach((p, i) => p.style.setProperty('--i', Math.min(i, 9)));
      el.classList.add('in');
      revealIO.unobserve(el);
      setTimeout(() => el.classList.add('settled'), Math.min(parts.length, 10) * 90 + 1100);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
  reveals.forEach(el => revealIO.observe(el));

  const draws = $$('.draw').map(el => ({ el, d: -1, vis: false }));
  const drawIO = new IntersectionObserver(es => {
    es.forEach(e => { const D = draws.find(x => x.el === e.target); if (D) D.vis = e.isIntersecting; });
    updateDraws();
  });
  draws.forEach(D => drawIO.observe(D.el));
  let drawsPinned = false;
  function updateDraws() {
    if (drawsPinned) return;
    const vh = innerHeight;
    draws.forEach(D => {
      if (!D.vis && D.d !== -1) return;
      const r = D.el.getBoundingClientRect();
      const d = clamp((vh - r.top) / (vh * 0.55 + r.height * 0.4), 0, 1);
      if (Math.abs(d - D.d) > 0.004 || ((d === 0 || d === 1) && d !== D.d)) { D.el.style.setProperty('--d', d.toFixed(3)); D.d = d; }
    });
  }

  const tk = $('.ticker');
  if (tk) {
    const items = ['Luxury fragrance', 'Ships in 1 to 3 business days', 'New York, USA', 'Wear your legacy'];
    const track = $('.ticker-track', tk);
    const half = document.createElement('div');
    half.style.display = 'flex';
    track.appendChild(half);
    let guard = 0;
    while (half.scrollWidth < 2600 && guard++ < 20) items.forEach(t => { const s = document.createElement('span'); s.textContent = t; half.appendChild(s); });
    track.appendChild(half.cloneNode(true));
    new IntersectionObserver(es => tk.classList.toggle('live', es[0].isIntersecting)).observe(tk);
  }

  const finder = $('.finder');
  if (finder) new IntersectionObserver(es => finder.classList.toggle('live', es[0].isIntersecting)).observe(finder);
  const fashion = $('.fashion');
  if (fashion) new IntersectionObserver(es => { if (es[0].isIntersecting) fashion.classList.add('in-view'); }, { threshold: 0.2 }).observe(fashion);

  const motes = $('.env-motes');
  if (motes && !RM.matches) {
    const r = rng(77);
    for (let i = 0; i < 16; i++) {
      const m = document.createElement('span');
      m.className = 'mote';
      m.style.left = (r() * 100).toFixed(2) + '%';
      m.style.setProperty('--s', (1.4 + r() * 1.8).toFixed(2) + 'px');
      m.style.setProperty('--dur', (48 + r() * 46).toFixed(1) + 's');
      m.style.setProperty('--del', (-r() * 90).toFixed(1) + 's');
      m.style.setProperty('--o', (0.18 + r() * 0.32).toFixed(2));
      m.style.setProperty('--dx', ((r() - 0.5) * 80).toFixed(1) + 'px');
      motes.appendChild(m);
    }
  }
  document.addEventListener('visibilitychange', () => document.body.classList.toggle('paused', document.hidden));

  /* ============================================================
     4. Nav: transparent over the film, ivory or night after
     ============================================================ */
  const nav = $('#nav');
  const themed = $$('[data-nav]').map(el => ({ el, t: el.dataset.nav }));
  let navState = '';
  function updateNav() {
    let state = hero ? 'clear' : 'night';
    for (const s of themed) {
      const r = s.el.getBoundingClientRect();
      if (r.top <= 72 && r.bottom > 72) { state = s.t; break; }
    }
    if (state !== navState) {
      nav.classList.toggle('solid', state === 'ivory');
      nav.classList.toggle('on-night', state === 'night');
      navState = state;
    }
  }
  let pageRaf = null;
  addEventListener('scroll', () => {
    if (pageRaf !== null) return;
    pageRaf = requestAnimationFrame(() => { pageRaf = null; updateNav(); updateDraws(); });
  }, { passive: true });
  addEventListener('resize', () => { updateNav(); updateDraws(); }, { passive: true });

  const menuBtn = $('.menu-btn');
  const sheet = $('#sheet');
  const setMenu = open => {
    menuBtn.setAttribute('aria-expanded', String(open));
    menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    sheet.hidden = !open;
  };
  menuBtn.addEventListener('click', () => setMenu(sheet.hidden));
  $$('a', sheet).forEach(a => a.addEventListener('click', () => setMenu(false)));

  /* ============================================================
     5. Toast
     ============================================================ */
  const toastEl = $('.toast');
  let toastTimer = null;
  function toast(html, ms = 3600) {
    if (!toastEl) return;
    toastEl.innerHTML = html;
    toastEl.hidden = false;
    requestAnimationFrame(() => toastEl.classList.add('on'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toastEl.classList.remove('on');
      setTimeout(() => { if (!toastEl.classList.contains('on')) toastEl.hidden = true; }, 500);
    }, ms);
  }

  /* ============================================================
     6. The bag: Shopify's own cart, drawn in the slide-out panel
     ============================================================ */
  const panel = $('#bag');
  const scrim = $('.bag-scrim');
  const list = $('.bag-items');
  const countEl = $('.bag-count');
  const checkoutBtn = $('.bag-checkout');
  const msg = $('.bag-msg');
  let cart = DATA.cart || { items: [], item_count: 0, items_subtotal_price: 0 };
  let busy = false;

  const cartApi = async (path, body) => {
    const res = await fetch(ROOT + path, body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }
      : { headers: { 'Accept': 'application/json' } });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'That did not work. Please try again.');
    return data;
  };
  const refreshCart = async () => { try { cart = await cartApi('cart.js'); renderBag(); } catch (_) {} };

  function renderBag() {
    const items = cart.items || [];
    const count = cart.item_count || 0;
    countEl.textContent = count;
    countEl.hidden = count === 0;
    $$('[data-open-bag]').forEach(b => { if (b.classList.contains('bag')) b.setAttribute('aria-label', count ? `Open your bag, ${count} item${count === 1 ? '' : 's'}` : 'Open your bag'); });
    list.innerHTML = items.map(i => {
      const p = byId[i.handle];
      const name = tidy(i.product_title);
      const img = (p && p.image) || i.image || '';
      const variant = i.product_has_only_default_variant ? '' : `<p class="bi-price">${esc(i.variant_title || '')}</p>`;
      const was = i.original_price > i.final_price ? ` <s>${money(i.original_price)}</s>` : '';
      return `<li class="bag-item" data-key="${esc(i.key)}">
        <a href="${esc(i.url)}">${img ? `<img src="${esc(img)}" alt="" width="72" height="90">` : ''}</a>
        <div class="bi-info"><p class="bi-name">${esc(name)}</p>${variant}<p class="bi-price">${money(i.final_price)}${was}</p>
          <div class="qty" role="group" aria-label="Quantity for ${esc(name)}">
            <button type="button" data-q="-1" aria-label="One less ${esc(name)}">−</button><span aria-live="polite">${i.quantity}</span><button type="button" data-q="1" aria-label="One more ${esc(name)}" ${i.quantity >= 10 ? 'disabled' : ''}>+</button>
          </div></div>
        <button class="bi-remove" type="button" data-remove aria-label="Remove ${esc(name)}">Remove</button>
      </li>`;
    }).join('');
    $('.bag-total').textContent = money(cart.items_subtotal_price || 0);
    panel.classList.toggle('is-empty', count === 0);
    checkoutBtn.disabled = count === 0;
  }

  function bumpCount() { countEl.classList.remove('bump'); void countEl.offsetWidth; countEl.classList.add('bump'); }

  async function addVariant(variantId, qty, name) {
    await cartApi('cart/add.js', { items: [{ id: +variantId, quantity: qty }] });
    cart = await cartApi('cart.js');
    renderBag();
    bumpCount();
    toast(`<span>${esc(name)} is in your bag.</span><button type="button" data-open-bag>View bag</button>`);
  }

  async function addToBag(id, btn) {
    const p = byId[id];
    if (!p || p.soldout || busy) return;
    busy = true;
    if (btn) btn.disabled = true;
    try { await addVariant(p.variant, 1, p.name); }
    catch (err) { toast(`<span>${esc(err.message)}</span>`, 5000); }
    busy = false;
    if (btn) btn.disabled = false;
  }

  async function changeLine(key, qty) {
    if (busy) return;
    busy = true;
    $$('button', list).forEach(b => { b.disabled = true; });
    try { cart = await cartApi('cart/change.js', { id: key, quantity: qty }); msg.textContent = ''; }
    catch (err) { msg.textContent = err.message; await refreshCart(); }
    busy = false;
    renderBag();
    if (!(cart.items || []).length) $('.bag-close', panel).focus();
  }

  let lastFocus = null;
  function openBag() {
    lastFocus = document.activeElement;
    msg.textContent = '';
    panel.hidden = false;
    scrim.hidden = false;
    document.documentElement.classList.add('bag-open');
    requestAnimationFrame(() => { panel.classList.add('open'); scrim.classList.add('open'); });
    setTimeout(() => $('.bag-close', panel).focus(), 60);
  }
  function closeBag() {
    panel.classList.remove('open');
    scrim.classList.remove('open');
    document.documentElement.classList.remove('bag-open');
    setTimeout(() => { if (!panel.classList.contains('open')) { panel.hidden = true; scrim.hidden = true; } }, RM.matches ? 0 : 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- larger photo view ---------- */
  const qv = $('#qv');
  const qvScrim = $('.qv-scrim');
  let qvP = null, qvI = 0, qvFocus = null;
  const qvOpen = () => qv && !qv.hidden;
  function showQv(i) {
    const n = qvP.images.length;
    qvI = (i + n) % n;
    $$('.qv-stage img', qv).forEach((img, k) => img.classList.toggle('on', k === qvI));
    $$('.qv-thumbs button', qv).forEach((b, k) => b.setAttribute('aria-current', String(k === qvI)));
    $('.qv-count', qv).textContent = n > 1 ? `${qvI + 1} / ${n}` : '';
  }
  function openQv(id) {
    const p = byId[id];
    if (!qv || !p) return;
    qvP = p;
    const imgs = p.images && p.images.length ? p.images : [p.image];
    qvP.images = imgs;
    const n = imgs.length;
    $('.qv-stage', qv).innerHTML = imgs.map((src, i) =>
      `<img src="${esc(src)}" alt="${esc(p.name)}${n > 1 ? `, photo ${i + 1} of ${n}` : ''}" draggable="false" ${i ? 'loading="lazy"' : ''}>`).join('');
    $('.qv-thumbs', qv).innerHTML = n > 1 ? imgs.map((src, i) =>
      `<li><button type="button" data-qv-i="${i}" aria-label="Show photo ${i + 1}"><img src="${esc(src)}" alt=""></button></li>`).join('') : '';
    $$('.qv-nav', qv).forEach(b => { b.hidden = n < 2; });
    $('.qv-notes', qv).textContent = p.notes || '';
    $('.qv-name', qv).textContent = p.name;
    $('.qv-line', qv).textContent = p.line || '';
    $('.qv-when', qv).innerHTML = p.when ? `<span>Wear it</span> ${esc(p.when)}` : '';
    $('.qv-desc', qv).innerHTML = p.desc || '';
    $('.qv-more', qv).href = p.url || '#';
    $('.qv-price', qv).innerHTML = money(p.price) + (p.was && p.was > p.price ? ` <s><span class="sr-only">Regular price </span>${money(p.was)}</s>` : '');
    const add = $('.qv-add', qv);
    add.dataset.add = p.id;
    add.disabled = !!p.soldout;
    add.innerHTML = p.soldout ? 'Sold out' : `Add to bag<span class="sr-only">: ${esc(p.name)}</span>`;
    showQv(0);
    qvFocus = document.activeElement;
    qv.hidden = false;
    qvScrim.hidden = false;
    document.documentElement.classList.add('bag-open');
    requestAnimationFrame(() => { qv.classList.add('open'); qvScrim.classList.add('open'); });
    setTimeout(() => $('.qv-close', qv).focus(), 60);
  }
  function closeQv(restore = true) {
    if (!qvOpen()) return;
    qv.classList.remove('open');
    qvScrim.classList.remove('open');
    document.documentElement.classList.remove('bag-open');
    setTimeout(() => { if (!qv.classList.contains('open')) { qv.hidden = true; qvScrim.hidden = true; } }, RM.matches ? 0 : 450);
    if (restore && qvFocus && qvFocus.focus) qvFocus.focus();
  }
  if (qv) {
    let sx = null;
    const stage = $('.qv-stage', qv);
    stage.addEventListener('pointerdown', e => { sx = e.clientX; });
    stage.addEventListener('pointerup', e => {
      if (sx === null || !qvP || qvP.images.length < 2) return;
      const dx = e.clientX - sx;
      sx = null;
      if (Math.abs(dx) > 40) showQv(qvI + (dx < 0 ? 1 : -1));
    });
    stage.addEventListener('pointercancel', () => { sx = null; });
  }

  document.addEventListener('click', e => {
    const add = e.target.closest('[data-add]');
    if (add) { addToBag(add.dataset.add, add); return; }
    const open = e.target.closest('[data-qv]');
    if (open) { openQv(open.dataset.qv); return; }
    if (e.target.closest('[data-close-qv]')) { closeQv(); return; }
    if (e.target.closest('.qv-prev')) { showQv(qvI - 1); return; }
    if (e.target.closest('.qv-next')) { showQv(qvI + 1); return; }
    const th = e.target.closest('[data-qv-i]');
    if (th) { showQv(+th.dataset.qvI); return; }
    if (e.target.closest('[data-open-bag]')) { e.preventDefault(); toastEl && toastEl.classList.remove('on'); closeQv(false); openBag(); return; }
    if (e.target.closest('[data-close-bag]')) { closeBag(); return; }
    const item = e.target.closest('.bag-panel .bag-item');
    if (item) {
      const it = (cart.items || []).find(i => i.key === item.dataset.key);
      if (!it) return;
      const q = e.target.closest('[data-q]');
      if (q) changeLine(it.key, clamp(it.quantity + (+q.dataset.q), 0, 10));
      else if (e.target.closest('[data-remove]')) changeLine(it.key, 0);
    }
  });

  addEventListener('keydown', e => {
    if (qvOpen()) {
      if (e.key === 'Escape') { closeQv(); return; }
      if (e.key === 'ArrowRight') { showQv(qvI + 1); return; }
      if (e.key === 'ArrowLeft') { showQv(qvI - 1); return; }
    }
    if (e.key === 'Escape') {
      if (!panel.hidden) closeBag();
      else if (!sheet.hidden) { setMenu(false); menuBtn.focus(); }
    }
    const trap = qvOpen() ? qv : (!panel.hidden ? panel : null);
    if (e.key === 'Tab' && trap) {
      const f = $$('button:not([disabled]), a[href]', trap).filter(x => x.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  checkoutBtn.addEventListener('click', () => {
    if (!(cart.items || []).length) return;
    checkoutBtn.disabled = true;
    checkoutBtn.textContent = 'Opening secure checkout...';
    location.href = ROOT + 'checkout';
  });

  renderBag();
  /* coming back with the browser's back button: the cart may have changed */
  addEventListener('pageshow', e => {
    if (!e.persisted) return;
    checkoutBtn.textContent = 'Checkout';
    refreshCart();
  });

  /* ---------- product page: photos, quantity, add to bag ---------- */
  const pdpForm = $('#pdp-form');
  const pdpStage = $('.pdp-stage');
  if (pdpStage) {
    const shots = $$('img', pdpStage);
    const thumbs = $$('.pdp-thumbs button');
    let cur = 0;
    const show = i => {
      if (shots.length < 2) return;
      cur = (i + shots.length) % shots.length;
      shots.forEach((img, k) => img.classList.toggle('on', k === cur));
      thumbs.forEach((b, k) => b.setAttribute('aria-current', String(k === cur)));
    };
    thumbs.forEach(b => b.addEventListener('click', () => show(+b.dataset.shot)));
    let sx = null;
    pdpStage.addEventListener('pointerdown', e => { sx = e.clientX; });
    pdpStage.addEventListener('pointerup', e => {
      if (sx === null) return;
      const dx = e.clientX - sx;
      sx = null;
      if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
    });
    pdpStage.addEventListener('pointercancel', () => { sx = null; });
  }
  $$('[data-step]').forEach(b => b.addEventListener('click', () => {
    const input = $('.qty-in', b.closest('.qty'));
    if (!input) return;
    input.value = clamp((parseInt(input.value, 10) || 1) + (+b.dataset.step), 1, 10);
  }));
  if (pdpForm) pdpForm.addEventListener('submit', async e => {
    e.preventDefault();
    const btn = $('.pdp-add', pdpForm);
    const note = $('.pdp-msg', pdpForm);
    const fd = new FormData(pdpForm);
    const name = ($('.pdp-name') || {}).textContent || 'Your scent';
    btn.disabled = true;
    note.textContent = '';
    try { await addVariant(fd.get('id'), clamp(parseInt(fd.get('quantity'), 10) || 1, 1, 10), name.trim()); }
    catch (err) { note.textContent = err.message; }
    btn.disabled = false;
  });

  const params = new URLSearchParams(location.search);
  if (params.has('bag')) setTimeout(openBag, 300);
  /* back from the family signup: bring the confirmation into view */
  if (params.has('customer_posted') && $('#family')) {
    setTimeout(() => $('#family').scrollIntoView({ block: 'center' }), 400);
  }
  if (params.has('bag') || params.has('customer_posted')) {
    history.replaceState(null, '', location.pathname + location.hash);
  }

  /* ============================================================
     7. Collection filter
     ============================================================ */
  const chips = $$('.chip-btn');
  const cards = $$('.card');
  const empty = $('.grid-empty');
  chips.forEach(btn => btn.addEventListener('click', () => {
    const f = btn.dataset.filter;
    chips.forEach(c => { const on = c === btn; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', String(on)); });
    let count = 0;
    cards.forEach(card => {
      const show = f === 'all' || (card.dataset.moods || '').split(' ').includes(f);
      card.classList.remove('pop');
      card.hidden = !show;
      if (show) { count++; void card.offsetWidth; card.classList.add('pop'); }
    });
    if (empty) empty.hidden = count > 0;
  }));

  /* ============================================================
     8. The finder: hold to let the drop land
     ============================================================ */
  let pinFinder = () => {}, unpinFinder = () => {};
  const fStage = $('.f-stage');
  if (fStage) {
    const holdBtn = $('.hold');
    const holdLabel = $('.hold-label');
    const holdHint = $('.hold-hint');
    const match = $('.match');
    const LABEL = () => RM.matches ? 'Show my scent' : 'Hold to reveal your scent';
    const HINT_READY = () => RM.matches ? 'Tap to see your match.' : 'Press and hold. Let it land.';
    let h = 0, holding = false, hRaf = null, hLast = 0, hShown = -1, done = false;

    const pick = (occ, mood) => {
      const pool = PRODUCTS.filter(p => !p.soldout);
      const scored = (pool.length ? pool : PRODUCTS).map((p, i) => ({
        p, s: ((p.moods || []).includes(mood) ? 2 : 0) + ((p.moments || []).includes(occ) ? 1 : 0) - i * 0.001
      }));
      scored.sort((a, b) => b.s - a.s);
      return [scored[0] && scored[0].p, scored[1] && scored[1].p];
    };
    const answers = () => {
      const o = $('input[name="occ"]:checked');
      const m = $('input[name="mood"]:checked');
      return o && m ? [o.value, m.value] : null;
    };
    holdLabel.textContent = LABEL();
    if (!PRODUCTS.length) holdHint.textContent = 'New scents are on the way.';
    $$('.opts input').forEach(i => i.addEventListener('change', () => {
      if (answers() && !done && PRODUCTS.length) { holdBtn.disabled = false; holdHint.textContent = HINT_READY(); }
    }));

    const writeH = () => {
      if (Math.abs(h - hShown) > 0.002 || ((h === 0 || h === 1) && h !== hShown)) { fStage.style.setProperty('--h', h.toFixed(3)); hShown = h; }
    };
    const holdLoop = t => {
      const dt = Math.min(64, t - (hLast || t));
      hLast = t;
      if (holding) h = Math.min(1, h + dt / 1300);
      else h = Math.max(0, h - (dt / 900) * (0.35 + h));
      writeH();
      if (h >= 1 && !done) { complete(); return; }
      if ((holding && h < 1) || (!holding && h > 0)) hRaf = requestAnimationFrame(holdLoop);
      else { hRaf = null; hLast = 0; }
    };
    const startHold = () => {
      if (holdBtn.disabled || done) return;
      if (RM.matches) { complete(); return; }
      holding = true;
      holdBtn.classList.add('holding');
      holdLabel.textContent = 'Keep holding...';
      if (hRaf === null) hRaf = requestAnimationFrame(holdLoop);
    };
    const endHold = () => {
      if (!holding) return;
      holding = false;
      holdBtn.classList.remove('holding');
      if (!done) holdLabel.textContent = LABEL();
      if (hRaf === null && h > 0) hRaf = requestAnimationFrame(holdLoop);
    };
    holdBtn.addEventListener('pointerdown', e => {
      if (holdBtn.disabled) return;
      e.preventDefault();
      try { holdBtn.setPointerCapture(e.pointerId); } catch (_) {}
      startHold();
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(ev => holdBtn.addEventListener(ev, endHold));
    holdBtn.addEventListener('keydown', e => { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); startHold(); } });
    holdBtn.addEventListener('keyup', e => { if (e.key === ' ' || e.key === 'Enter') endHold(); });
    holdBtn.addEventListener('click', e => { e.preventDefault(); if (RM.matches) startHold(); });
    holdBtn.addEventListener('contextmenu', e => e.preventDefault());

    function complete() {
      const a = answers();
      if (!a) return;
      const [p, q] = pick(a[0], a[1]);
      if (!p) return;
      done = true;
      holding = false;
      h = 1;
      writeH();
      holdBtn.classList.remove('holding');
      holdBtn.disabled = true;
      holdLabel.textContent = LABEL();
      $('.match-img', match).src = p.image;
      $('.match-name', match).textContent = p.name;
      $('.match-line', match).textContent = p.line || '';
      $('.match-price', match).innerHTML = money(p.price) + (p.was && p.was > p.price ? ` <s><span class="sr-only">Regular price </span>${money(p.was)}</s>` : '');
      const addBtn = $('.match-add', match);
      addBtn.dataset.add = p.id;
      addBtn.disabled = !!p.soldout;
      addBtn.innerHTML = p.soldout ? 'Sold out' : `Add to bag<span class="sr-only">: ${esc(p.name)}</span>`;
      $('.match-also', match).innerHTML = q ? `Also try: <a href="#p-${esc(q.id)}">${esc(q.name)}</a>` : '';
      const H = fStage.clientHeight;
      fStage.style.setProperty('--fall', Math.round(H / 2 + 70 - H * 0.08 - 9) + 'px');
      fStage.classList.add('done');
      const show = () => { match.hidden = false; requestAnimationFrame(() => requestAnimationFrame(() => match.classList.add('lit'))); };
      if (RM.matches) show(); else setTimeout(show, 1500);
    }

    $('.reset', match).addEventListener('click', () => {
      match.classList.remove('lit');
      match.hidden = true;
      fStage.classList.remove('done');
      done = false;
      h = 0;
      writeH();
      holdLabel.textContent = LABEL();
      holdBtn.disabled = !answers();
      holdHint.textContent = answers() ? HINT_READY() : 'Pick one of each first.';
      holdBtn.focus();
    });

    pinFinder = () => {
      if (holding) endHold();
      if (hRaf !== null) { cancelAnimationFrame(hRaf); hRaf = null; }
      holdLabel.textContent = LABEL();
      if (answers() && !done) holdHint.textContent = HINT_READY();
    };
    unpinFinder = pinFinder;
  }

  /* ============================================================
     9. FAQ and the family signup
     ============================================================ */
  $$('.qa button').forEach(btn => btn.addEventListener('click', () => {
    const open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', String(open));
    btn.closest('.qa').classList.toggle('open', open);
  }));

  /* ============================================================
     10. Reduced motion, honored live in both directions
     ============================================================ */
  function pinToFinalStates() {
    drawsPinned = true;
    draws.forEach(D => { D.el.style.setProperty('--d', '1'); D.d = 1; });
    reveals.forEach(el => el.classList.add('in', 'settled'));
    pinFinder();
  }
  function unpinFinalStates() {
    if (!drawsPinned) return;
    drawsPinned = false;
    draws.forEach(D => { D.d = -1; });
    updateDraws();
    unpinFinder();
  }
  unpinHero = unpinFinalStates;
  RM.addEventListener('change', e => {
    if (e.matches) pinToFinalStates();
    else { unpinFinalStates(); applyHeroMode(); }
  });

  if (RM.matches) pinToFinalStates();
  applyHeroMode();
  updateNav();
  updateDraws();
})();
